
const ActivationPage: React.FC = () => {
  return <h1>Activation Page</h1>;
};

export default ActivationPage;
